import { useState } from "react";
import { ArrowRight, Heart, Menu, Tag, X } from "lucide-react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { Logo } from "../components/Logo";
import { DiscordAlertPrompt } from "../components/DiscordAlertPrompt";
import { useLocalVehicles } from "../context/LocalVehicleContext";

const links: Array<[string, string]> = [
  ["/", "Inicio"],
  ["/reservas", "Reservas"],
  ["/contacto", "Contacto"],
  ["/comparar", "Comparar"],
];

export function PublicLayout() {
  const [open, setOpen] = useState(false);
  const { favorites } = useLocalVehicles();

  return (
    <div className="min-h-screen bg-gangacars-ink">
      <header className="sticky top-0 z-50 border-b border-white/10 bg-gangacars-ink/95 backdrop-blur-xl">
        <div className="gc-retail-strip">
          <div className="shell flex h-full items-center justify-center gap-3 text-center">
            <Tag size={13} aria-hidden="true" />
            <span>Precios claros</span><i aria-hidden="true" />
            <span>Compra fácil</span>
          </div>
        </div>
        <div className="shell gc-header-main flex items-center justify-between gap-5">
          <div className="gc-header-logo shrink-0"><Logo compact /></div>
          <nav className="hidden self-stretch lg:flex" aria-label="Principal">
            {links.map(([to, label]) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/"}
                className={({ isActive }) => `gc-nav-link ${isActive ? "is-active" : ""}`}
              >
                {label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden items-center gap-2 lg:flex">
            <div className="mr-2 flex items-center gap-1 border-r border-gangacars-line pr-4">
              <Link to="/vehiculos?favorites=true" className="gc-header-action" aria-label={`Favoritos: ${favorites.length}`}>
                <Heart size={18} aria-hidden="true" />
                <span className="hidden xl:inline">Favoritos</span>
                <b>{favorites.length}</b>
              </Link>
            </div>
            <Link to="/vehiculos" className="gc-header-cta">
              Ver coches <ArrowRight size={17} aria-hidden="true" />
            </Link>
          </div>
          <button
            type="button"
            className="rounded-md border border-gangacars-line bg-white/5 p-2.5 lg:hidden"
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            aria-controls="mobile-navigation"
            aria-label={open ? "Cerrar menú" : "Abrir menú"}
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
        {open && (
          <nav id="mobile-navigation" className="gc-mobile-nav shell lg:hidden" aria-label="Navegación móvil">
            <div className="grid gap-1 py-3 sm:grid-cols-2">
              {links.map(([to, label]) => (
                <NavLink key={to} to={to} end={to === "/"} onClick={() => setOpen(false)} className={({ isActive }) => `gc-mobile-nav-link ${isActive ? "is-active" : ""}`}>
                  {label}
                </NavLink>
              ))}
            </div>
            <div className="border-t border-gangacars-line py-3">
              <Link to="/vehiculos?favorites=true" onClick={() => setOpen(false)} className="gc-mobile-action w-full">
                <Heart size={17} aria-hidden="true" /> Favoritos <b>{favorites.length}</b>
              </Link>
            </div>
          </nav>
        )}
      </header>
      <main><Outlet /></main>
      <DiscordAlertPrompt />
      <footer className="border-t border-gangacars-line bg-black py-10">
        <div className="shell grid gap-8 md:grid-cols-3">
          <div><Logo compact /><p className="mt-3 max-w-sm text-sm text-slate-500">Coches · Mejores precios. Más coche por menos.</p></div>
          <div><h2 className="font-display text-lg uppercase">Concesionario</h2><p className="mt-3 text-sm leading-6 text-slate-500">Puerta del Sol<br />Los Santos, San Andreas</p></div>
          <div className="flex flex-col gap-2 md:items-end"><Link to="/contacto" className="text-sm text-slate-500 hover:text-white">Contacta con nosotros</Link><Link to="/login" className="text-sm text-slate-500 hover:text-white">Acceso empleados</Link></div>
        </div>
      </footer>
    </div>
  );
}
